import storeRoot from '../store-root'
import http from '../../services/http'
import queryString from 'querystring'
const moduleName = 'equipmentV2'
storeRoot.registerModule(moduleName, {
  namespaced: true,
  state: {
    activeTitle: '',
    basic: null,
    equipmentData: {},
    currentEnterprise: {}
  },
  actions: {
    // 获取当前公司的简单视图
    async getEnterprise ({ commit }, payload) {
      let result = await http.get(`/api/Enterprise/Simple`)
      commit('setcurrentEnterprise', result.data)
      return result.data
    },
    // 首页获取水质参数,远程控制
    async getEquipmentsData ({ commit }, payload) {
      let result = await http.get(`/api/EquipmentSocket/GetEquipmentsData?${queryString.stringify(payload)}`)
      commit('setEquipmentsData', result.data)
      return result.data
    },
    // 远程控制全开,全关
    async controlAllSwitch ({ commit }, payload) {
      let result = await http.put(`/api/EquipmentSocket/RemoteAllCtrl?${queryString.stringify(payload)}`)
      return result.data
    },
    // 远程控制单一开关
    async controlSwitch ({ commit }, payload) {
      let result = await http.put(`/api/EquipmentSocket/RemoteCtrl?${queryString.stringify(payload)}`)
      return result.data
    },
    // 获取设备列表
    async getEquipmentList ({ commit }, payload) {
      let result = await http.get(`/api/Equipment`)
      return result.data
    },
    // 新增设备
    async addEquipment ({ commit }, payload) {
      let result = await http.post(`/api/Equipment`, payload)
      return result.data
    },
    // 根据公司获取基地
    async getBaseList ({ commit }, payload) {
      let result = await http.get(`/api/BaseWithPond/Base?${queryString.stringify(payload)}`)
      return result.data
    },
    // 根据基地Id获取塘口
    async getpondList ({ commit }, payload) {
      let result = await http.get(`/api/BaseWithPond/Pond?${queryString.stringify(payload)}`)
      return result.data
    },
    // 切换记录状态
    async switchTimer ({ commit }, payload) {
      let result = await http.put(`/api/SwithTimer/Switch?${queryString.stringify(payload)}`)
      return result.data
    },
    // 获取视频列表
    async getVideoMonitoring ({ commit }, payload) {
      let result = await http.get(`api/VideoMonitoring/2?${queryString.stringify(payload)}`)
      return (result.data)
    },
    // 获取平台下 所有公司 基地/塘口设备列表（带有传感器数据和开关状态）
    async getEquipmentPlatformDataList ({ commit }, payload) {
      let result = await http.get(`api/Equipment/GetEquipmentPlatformDataList`)
      return (result.data)
    }
  },
  mutations: {
    setEquipmentsData (state, payload) {
      state.equipmentData = payload
    },
    setcurrentEnterprise (state, payload) {
      state.currentEnterprise = payload
    },
    setActiveTitle (state, payload) {
      state.activeTitle = payload
    },
    setChooseBasic (state, payload) {
      state.basic = payload
    }
  }
})

export default moduleName
